export const APPDOWNLOADBANNERLINKS = {
  HOMEPAGE: 'https://hostelworld.onelink.me/IdiK/o4e0z8xk',

  WORLDWIDE: 'https://hostelworld.onelink.me/IdiK/zfz2inhe',

  CONTINENT: 'https://hostelworld.onelink.me/IdiK/0tz4sdmj',

  COUNTRY: 'https://hostelworld.onelink.me/IdiK/f5168gpb',

  AREA: 'https://hostelworld.onelink.me/IdiK/ck5odmzm',

  REGION: 'https://hostelworld.onelink.me/IdiK/24o49vyu',

  CITY: 'https://hostelworld.onelink.me/IdiK/pte4dvbo',

  DISTRICT: 'https://hostelworld.onelink.me/IdiK/0adndjf8',

  PROPERTY: 'https://hostelworld.onelink.me/IdiK/h8b6frh3',

  MENU: 'https://hostelworld.onelink.me/IdiK/l5wn8um8',

  SOCIALHIGHLIGHTS: 'https://hostelworld.onelink.me/IdiK/9v6e37wq',

  EVENTS: {
    WORLDWIDE: {
      mobile: 'https://hostelworld.onelink.me/IdiK/uahofxz2',
      desktop: 'https://hostelworld.onelink.me/IdiK/5dyo10cv',
    },

    CONTINENT: {
      mobile: 'https://hostelworld.onelink.me/IdiK/09j85yu6',
      desktop: 'https://hostelworld.onelink.me/IdiK/52nej5ka',
    },

    COUNTRY: {
      mobile: 'https://hostelworld.onelink.me/IdiK/8dvfpsns',
      desktop: 'https://hostelworld.onelink.me/IdiK/yxgx3ml6',
    },

    CITY: {
      mobile: 'https://hostelworld.onelink.me/IdiK/xsdkqjby',
      desktop: 'https://hostelworld.onelink.me/IdiK/gtugay8y',
    },

    DETAILS: {
      mobile: 'https://hostelworld.onelink.me/IdiK/wrubgk4y',
      desktop: 'https://hostelworld.onelink.me/IdiK/a6wn8lkd',
    },
  },
};
